import { render, staticRenderFns } from "./differDetailDialog.vue?vue&type=template&id=ca565fa8&scoped=true"
import script from "./differDetailDialog.vue?vue&type=script&lang=js"
export * from "./differDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./differDetailDialog.vue?vue&type=style&index=0&id=ca565fa8&prod&lang=scss&scoped=true"
import style1 from "./differDetailDialog.vue?vue&type=style&index=1&id=ca565fa8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca565fa8",
  null
  
)

export default component.exports